import { render, staticRenderFns } from "./channel-edit.vue?vue&type=template&id=31eb79a8&scoped=true&"
import script from "./channel-edit.vue?vue&type=script&lang=js&"
export * from "./channel-edit.vue?vue&type=script&lang=js&"
import style0 from "./channel-edit.vue?vue&type=style&index=0&id=31eb79a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb79a8",
  null
  
)

export default component.exports